import { render } from "./OrderGeneralInformationTab.vue?vue&type=template&id=2f74253b&scoped=true"
import script from "./OrderGeneralInformationTab.vue?vue&type=script&lang=js"
export * from "./OrderGeneralInformationTab.vue?vue&type=script&lang=js"

import "./OrderGeneralInformationTab.vue?vue&type=style&index=0&id=2f74253b&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f74253b"]])

export default __exports__